import { useCallback } from 'react';
import useUser from 'Hooks/useUser';
import { formatDate, formatNumber } from 'Utils/formatters';

const useNumberUtils = () => {
  const { data: user = {} } = useUser();

  const formatNumberWrapper = useCallback(
    (number, opts) => formatNumber(number, {
      ...(opts || {}),
      locale: `${ user?.language || 'ro' }-US`
    }),
    []
  );
  const formatDateWrapper = useCallback(
    (number, opts) => formatDate(number, {
      ...(opts || {}),
      locale: `${ user?.language || 'ro' }-US`
    }),
    []
  );
  return { formatNumber: formatNumberWrapper, formatDate: formatDateWrapper };
};

export default useNumberUtils;
